import React from 'react';
import { Link } from 'react-router-dom';
import './WhyChooseUs.css';

const reasons = [
  {
    title: 'End to End Solutions',
    description: 'Design, Development, Marketing & Growth under one roof.',
  },
  {
    title: 'Future-Ready AI Expertise',
    description: 'Leverage AI & Automation to stay ahead.',
  },
  {
    title: 'Results-Focused SEO & Marketing',
    description: 'Strategies built to drive traffic & conversions.',
  },
  {
    title: 'Client-Centric Approach',
    description: 'Transparent communication, on time delivery, scalable solutions.',
  },
];

const WhyChooseUs = () => (
  <section className="why-choose">
    <div className="why-choose-container">
      <div className="why-header">
        <p className="why-label">WHY CHOOSE US</p>
        <h2 className="why-title">Building digital products with confidence</h2>
        <p className="why-subtitle">We turn complex ideas into measurable growth with a multidisciplinary crew.</p>
      </div>

      <div className="why-grid">
        {reasons.map((reason, index) => (
          <article key={reason.title} className="why-card">
            <span className="why-number">0{index + 1}</span>
            <h3 className="why-card-title">{reason.title}</h3>
            <p className="why-card-description">{reason.description}</p>
          </article>
        ))}
      </div>

      <div className="why-cta">
        <p className="why-cta-text">Ready to scale your digital presence?</p>
        <Link to="/contact" className="why-cta-button">Contact Us</Link>
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
